<template>
  <div class="wrap relative" v-if="ready">
    <SiteHeader bg="false"></SiteHeader>

    <div
      class="caseStudyWrap"
      id="caseStudyWrap"
      :class="{
        'caseStudyWrap--blue': data.color === 'blue',
        'caseStudyWrap--darkblue': data.color === 'darkblue',
        'caseStudyWrap--red': data.color === 'red',
        'caseStudyWrap--orange': data.color === 'orange',
        'caseStudyWrap--green': data.color === 'green',
        'caseStudyWrap--purple': data.color === 'purple',
        'caseStudyWrap--brown': data.color === 'brown'
      }"
    >
      <div class="outer relative sect sect-cs-header">
        <div class="inner relative">
          <div class="sect-content">
            <!-- <div class="sect-cs-no">{{ padd(data.id + 1) }}</div> -->
            <div class="sect-cs-header-descriptor">
              Case study
              <span>{{ padd(data.id + 1) }}</span>
              <span class="csLoopNavInheader inline-block inline-block">
                <router-link
                  :to="{ name: 'case-study', params: { case: data.next.slug } }"
                  class="inline-block leading-none"
                >
                  <svgicon
                    class="svg-fill cursor-pointer align-middle inline-block"
                    name="chevron-left"
                    width="30"
                    height="30"
                    color="#fff"
                    title="Previous case study."
                  />
                </router-link>
                <router-link
                  :to="{ name: 'case-study', params: { case: data.next.slug } }"
                  class="inline-block leading-none"
                >
                  <svgicon
                    class="svg-fill cursor-pointer align-middle inline-block"
                    name="chevron-right"
                    width="30"
                    height="30"
                    color="#fff"
                    title="Next case study."
                  />
                </router-link>
              </span>
            </div>
            <div class="sect-cs-header-title" v-html="data.title"></div>
          </div>
        </div>
      </div>

      <div class="scrollWrap" data-sticky-container>
        <div class="outer relative sect sect-cs-need" id="sect-cs-need">
          <div class="inner relative mb-0">
            <div class="sect-content">
              <div class="csDescriptor">
                <h2 id="work" class="heading-two">Business requirement</h2>
                <p class="copy-lg" v-html="data.business_need"></p>
              </div>
            </div>

            <div class="csSidebar" data-sticky-for="950">
              <div class="csSidebarWrap">
                <div class="csSidebarContent">
                  <svgicon class="icon std-grey" name="briefcase" width="20" />
                  <abbr title="Chief Information Officer">CIO</abbr> watchlist:
                  <span>{{ data.cio_watchlist }}</span>
                </div>
                <div class="csSidebarContent">
                  <svgicon class="icon std-grey" name="scale" width="20" />
                  Scale: <span v-html="data.scale"></span>
                </div>
                <div class="csSidebarContent">
                  <svgicon class="icon std-grey" name="icon-projects" width="20" />
                  Programme Management: <span v-html="data.programme_mgmt"></span>
                </div>
                <span v-if="haveTestimonial()">
                  <div
                    class="csSidebarContent csSidebarContent--quote no:skewY"
                    v-for="item in data.testimonials"
                    :key="item.$index"
                  >
                    <div v-html="item.content"></div>
                    <div class="cs-quote-person" v-if="item.person">
                      <span v-html="item.person"></span>
                    </div>
                    <div class="cs-quote-icon open">
                      <svgicon class="svg-fill" name="quote" width="40" />
                    </div>
                    <div class="cs-quote-icon close">
                      <svgicon class="svg-fill" name="quote" width="40" />
                    </div>
                  </div>
                </span>
              </div>
            </div>
          </div>
        </div>

        <div class="outer relative sect sect-cs-inclusions">
          <div class="inner relative mb-0">
            <div class="sect-content">
              <h2 id="cs-inclusions" class="heading-two">What we did</h2>
              <div class="list-wrap">
                <ul class="first">
                  <li v-for="(item, i) in data.inclusions.A" :key="i" class="copy-md">
                    <svgicon name="chevron-right" width="20" />
                    <span v-html="item"></span>
                  </li>
                </ul>
                <ul class="second">
                  <li v-for="(item, i) in data.inclusions.B" :key="i" class="copy-md">
                    <svgicon name="chevron-right" width="20" />
                    <span v-html="item"></span>
                  </li>
                </ul>
              </div>
            </div>
            <!-- <div class="sect-chart"> -->
            <!-- <process-pie-chart :roles="data.pipefish_role"></process-pie-chart> -->
            <!-- </div> -->
          </div>
        </div>

        <div class="outer relative sect sect-cs-outcome pb-0 mb-0">
          <div class="inner relative mb-0 pb-0">
            <div class="sect-content">
              <div class="csDescriptor">
                <h2 id="cs-inclusions" class="heading-two">Successful outcome</h2>
                <p class="copy-lg" v-html="data.outcome"></p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ContentSection skew="none" id="our-people" class="z-0 bg-white pb-20">
        <div class="max-w-5xl mx-auto">
          <div class="sect-contact">
            <div class="inner relative">
              <div class="sect-content bg-grey-100">
                <svgicon
                  name="footer-contact-us"
                  class="orange"
                  color="#ffffff"
                  width="40"
                  height="40"
                  title="Contact us"
                />
                <h3>Want to know more about <strong v-html="data.title"></strong>?</h3>
                <div>
                  <button
                    type="button"
                    class="button button--primary relative"
                    @click="toggleContactUsModal(data.title)"
                  >
                    Contact us
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ContentSection>

      <div class="footer-cs-nav">
        <router-link :to="{ name: 'case-study', params: { case: data.prev.slug } }" class="prev">
          <div class="label" v-html="data.prev.title"></div>
          <svgicon class="svg-fill" name="chevron-left" width="80" height="80" />
        </router-link>
        <router-link :to="{ name: 'case-study', params: { case: data.next.slug } }" class="next">
          <div class="label" v-html="data.next.title"></div>
          <svgicon
            class="svg-fill"
            name="chevron-right"
            width="80"
            height="80"
            color="#AAAAAA"
            :fill="true"
          />
        </router-link>
      </div>
    </div>
    <SiteFooter></SiteFooter>
  </div>
</template>

<script>
// var Sticky = require('sticky-js');
import Sticky from 'sticky-js';
import SiteHeader from '@/components/SiteHeader.vue';
import SiteFooter from '@/components/Footer.vue';
import ContentSection from '@/components/ContentSection.vue';
// import ProcessPieChart from '@/components/ProcessPieChart.vue';
import _ from 'lodash';
import '@/components/svg/icon-check';
import '@/components/svg/chevron-left';
import '@/components/svg/chevron-right';
import '@/components/svg/footer-contact-us';
export default {
  name: 'CaseStudies',
  components: {
    SiteHeader,
    SiteFooter,
    ContentSection
    // ProcessPieChart
  },
  data: function() {
    return {
      ready: false,
      data: null,
      publicPath: process.env.BASE_URL
    };
  },
  computed: {
    // csImage: {
    //   get: function() {
    //     return `./assets/tile-${this.data.slug}@2x.png`;
    //   },
    //   set: function() {}
    // },
    // csNav: {
    //   get: function() {
    //     return '';
    //   },
    //   set: function() {
    //     return '';
    //   }
    // }
  },
  methods: {
    toggleContactUsModal: function(title) {
      // this.$store.dispatch('toggleContactUsModal');
      // this.Store.dispatch('toggleContactUsModal', { title: title });
      this.Store.toggleContactUsModal({ title: title });
    },
    // goNext: function() {
    //   this.$router.push({ name: 'case-study', params: { case: this.data.next.slug } });
    // },
    // goPrev: function() {
    //   this.$router.push({ name: 'case-study', params: { case: this.data.prev.slug } });
    // },
    haveTestimonial() {
      return this.data.testimonials && this.data.testimonials.length > 0;
    },
    getData: function() {
      var vm = this;
      this.data = _.find(vm.Store.caseStudies, function(item) {
        return item.slug === vm.$route.params.case;
      });
      this.ready = true;
    },
    padd: function(num) {
      if (num < 10) {
        return '0' + num;
      } else {
        return num;
      }
    }
  },
  mounted: function() {
    this.$nextTick(function() {
      this.getData();
      setTimeout(function() {
        this.sticky = new Sticky('.csSidebar');
      }, 300);
    });
  }
};
</script>

<style lang="scss">
@mixin caseStudyTheme($primary) {
  .sect-cs-header,
  .button--primary {
    background: $primary !important;
  }
  .sect-cs-header .csLoopNavInheader > a {
    &:hover {
      svg path {
        fill: $primary !important;
      }
    }
  }

  .csSidebar .csSidebarWrap .csSidebarContent > span,
  .heading-two,
  .footer-cs-nav,
  .footer-cs-nav .label,
  .footer-cs-nav .prev:hover,
  .footer-cs-nav .prev:hover .label,
  .footer-cs-nav .next:hover,
  .footer-cs-nav .next:hover .label,
  .cs-quote-person {
    color: $primary !important;
  }
  .heading-two {
    &:after {
      background: rgba($primary, 0.7) !important;
    }
  }
  .footer-cs-nav .prev .svg-icon path,
  .footer-cs-nav .prev:hover .svg-icon path,
  .footer-cs-nav .next .svg-icon path,
  .footer-cs-nav .next:hover .svg-icon path {
    fill: $primary !important;
  }
  .csSidebar .csSidebarContent--quote .cs-quote-icon {
    background: rgba($primary, 0.8) !important;
  }
  .sect-contact {
    svg {
      g,
      g path {
        fill: $primary !important;
      }
    }
    h3 {
      strong {
        color: $primary;
      }
    }
  }
  .sect-cs-inclusions .list-wrap svg {
    g {
      path {
        fill: rgba($primary, 0.8) !important;
      }
      circle {
        stroke: rgba($primary, 0.8) !important;
      }
    }
  }
  .csSidebar .csSidebarContent svg,
  .sect-cs-header .csLoopNavInheader > span:hover svg {
    g,
    path,
    line,
    circle,
    ellipse,
    rect {
      fill: $primary !important;
    }
    circle,
    ellipse,
    rect {
      fill: none;
    }
  }
}

$sidebarAdjust: 170px;

.caseStudyWrap {
  margin-top: -150px;
  padding-top: 150px;

  .button--primary {
    background: darken($CaseStudyBlue, 5%);
  }
  .heading-two {
    color: $CaseStudyBlue;
    &:after {
      background: rgba($CaseStudyBlue, 0.7) !important;
    }
  }

  .scrollWrap {
    @include media('>=950px') {
      margin-top: (0 - $sidebarAdjust);
    }
    margin-bottom: 30px;
  }

  .sect-cs-header {
    transform: skewY($skew);
    background: rgba(darken($CaseStudyBlue, 0%), 1);
    color: #fff;
    position: relative;
    z-index: 300;
    margin-top: 48px;
    // min-height: 290px;
    .inner {
      transform: skewY($-skew);
      @include media('>=medium') {
        margin-top: 20px;
      }
      .sect-cs-header-descriptor {
        font-family: $font-family;
        color: rgba(#fff, 0.8);
        text-transform: uppercase;
        font-size: 20px;
        font-weight: 400;
        padding: 0;
        margin: 0px 0 10px 0;
        position: relative;
        // top: -20px;
        @include media('>=medium') {
          // top: auto;
          font-size: 25px;
        }
        > span {
          // font-size: 150%;
          // font-weight: 400;
          color: rgba(#fff, 0.8);
        }
      }
      .sect-cs-header-title {
        font-family: $brand-font-family;
        font-size: 40px;
        line-height: 1em;
        padding: 0 0 0px 0;
        margin: 0;
        font-weight: 400;
        // max-width: 650px;
        @include media('>=medium') {
          font-size: 60px;
        }
      }

      .csLoopNavInheader {
        margin-left: 10px;
        > span,
        > a {
          margin-top: -5px !important;
          display: inline-block !important;
          cursor: pointer;
          svg {
            cursor: pointer;
          }
          &:hover {
            svg {
              // padding: 0 !important;
              // margin: 0 !important;
              background: #fff;
              // background: green;
              path {
                // fill: $PriBlueDark;
                fill: $PriBlueDark;
              }
            }
          }
        }
      }
    }
  }

  .sect-cs-need {
    z-index: 310;
    @include media('>950px') {
    }
    .sect-content {
      width: 100%;
      @include media('>=420px') {
        margin-bottom: 40px;
      }
      @include media('>950px') {
        transform: translateY($sidebarAdjust);
        padding-bottom: $sidebarAdjust;
        width: 470px;
      }
    }
  }

  .sect-cs-inclusions {
    transform: skewY($-skew) translateY(0px);
    background: rgba($Grey1WhiteSmoke, 0.7);
    color: #222;
    position: relative;
    z-index: 70;
    margin-bottom: 100px;
    padding-bottom: 70px;
    .inner {
      // margin-top: 80px;
      // padding-bottom: 60px;
      .sect-content {
        transform: skewY($skew) translateY(0px);
        width: 100%;
        @include media('>950px') {
          width: 50%;
        }

        .list-wrap {
          @include media('<950px', '>600px') {
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
          }
          ul {
            list-style: none;
            padding: 0;
            margin: 0 0 0 0;
            width: 100%;
            @include media('>400px') {
              margin-right: 40px;
            }

            &.first {
              margin-top: 30px;
              @include media('<950px', '>600px') {
                margin-top: 30px;
              }
            }
            &.second {
              @include media('<950px', '>600px') {
                margin-top: 30px;
              }
            }

            li {
              list-style: none;
              padding: 0 0 15px 25px;
              margin: 0;
              position: relative;
              // font-size: 17px;
              > svg {
                position: absolute;
                top: 4px;
                left: 0px;
                width: 15px;
                height: 15px;
              }

              @include media('>=medium') {
                padding-left: 40px;
                // font-size: 18px;
                > svg {
                  top: 6px;
                  width: 15px;
                  height: 15px;
                }
              }
            }
          }
        }
      }
      .sect-chart {
        transform: skewY($skew) translateY(0);
        margin-top: 30px;
        @include media('<850px') {
          padding-bottom: 0;
        }

        @include media('>=850px') {
          position: absolute;
          top: 0px;
          // bottom: -0px;
          right: 20px;
          width: 400px;
        }

        svg {
          width: 100%;
        }

        @include media('>=1100px') {
          // bottom: -50px;
          right: -50px;
          width: 500px;
        }

        @include media('>=1300px') {
          // bottom: -50px;
          right: -50px;
          width: 450px;
        }

        svg.svg-icon {
          position: absolute;
          bottom: 0px;
          right: 0px;
        }

        // img {
        //   margin: 10px auto;
        //   padding-right: 20px;
        //   display: block;
        // }
      }
    }
  }

  .sect-cs-outcome {
    color: #222;
    position: relative;
    z-index: 70;
    top: -50px;
    padding: 40px 0;
    @include media('>=medium') {
      padding: 60px 0;
    }
    .inner {
      margin-top: 0px;
      padding-bottom: 40px;
      .sect-content {
        width: 100%;
        @include media('>950px') {
          width: 450px;
        }
      }
    }
  }

  .footer-cs-nav {
    $height: 200px;
    $borderColor: #eee;
    background: rgba(#fff, 0.9);
    height: ($height * 0.7);
    padding: 0;
    margin: 0 0 0 0;
    border-top: 1px solid $borderColor;
    position: relative;
    @include media('>=medium') {
      height: $height;
    }
    .prev {
      border-right: 1px solid $borderColor;
      position: absolute;
      left: 0;
      right: 50%;
    }
    .next {
      position: absolute;
      left: 50%;
      right: 0;
    }
    .prev,
    .next {
      cursor: pointer;
      width: 50%;
      height: ($height * 0.7);
      position: absolute;
      display: inline-block;
      @include media('>=medium') {
        height: $height;
      }
      .label {
        display: none;
        position: absolute;
        top: 75%;
        left: 50%;
        transform: translateX(-50%) translateY(-30%);
        // text-transform: uppercase;
        font-size: 13px;
        // color: #ccc;
        color: $CaseStudyBlue;
        text-align: center;
        @include media('>=medium') {
          display: block;
        }
      }
      .svg-icon {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translateX(-50%) translateY(-50%);
        @include media('>=medium') {
          top: 40%;
        }
        path {
          // fill: #ccc !important;
          fill: $CaseStudyBlue !important;
        }
      }
      &:hover {
        background: $Grey1;
        color: $CaseStudyBlue;
        .label {
          // color: #fff;
          color: $CaseStudyBlue;
        }
        .svg-icon path {
          // fill: #666 !important;
          // fill: #fff !important;
          fill: $CaseStudyBlue !important;
        }
      }
    }
  }

  // Floating sidebar
  .csSidebar {
    @include rtp_transition($property: 'top', $duration: 0.2s);
    margin: 0 auto;
    padding: 0 0 0 0;
    min-height: 200px;
    // min-width: 400px;
    width: 100%;
    max-width: 400px;
    @include media('>600px') {
      min-width: 550px;
    }
    @include media('>950px') {
      // width: 450px;
      top: 0;
      right: 20px;
      z-index: 9999999;
      position: absolute;
      margin: 0;
      min-width: 400px;
    }
    .csSidebarWrap {
      box-shadow: 0 0 7px 0 rgba(#000, 0.3);
      margin-top: 20px;
      background: #ffffff;
    }

    .csSidebarContent {
      padding: 17px 45px;
      margin: 0 auto;
      border-bottom: 1px solid #eee;
      font-size: 17px;
      font-family: $brand-font-family;
      position: relative;
      color: $Grey5Chicago;
      > span {
        color: $CaseStudyBlue;
      }

      > .icon {
        position: absolute;
        left: 13px;
        top: 18px;
        // transform: translateY(-50%);

        g,
        path,
        line,
        circle,
        ellipse,
        rect {
          fill: $CaseStudyBlue;
        }
        circle,
        ellipse,
        rect {
          fill: none;
        }
      }

      &--quote {
        // padding: 25px !important;
        @include media('>950px') {
          transform: skewY($-skew) translateY(0px) translateX(0%);
        }
        .cs-quote-person {
          position: relative;
          font-style: normal;
          margin: 8px 0 0 8px;
          font-size: 12px;
          font-weight: 600;
          padding: 0 0 0 30px;
          color: $CaseStudyBlue;
          &:before {
            content: '';
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            left: 0;
            border-top: 1px solid #555;
            width: 20px;
          }
        }
        .cs-quote-icon {
          $quoteOpenSize: 40px;
          $quoteOpenSizeSM: 35px;
          position: absolute;
          top: 10px;
          left: 0px;
          width: $quoteOpenSizeSM;
          height: $quoteOpenSizeSM;
          border-radius: 50%;
          transform: translateX(-50%) translateY(0%);
          background: rgba($CaseStudyBlue, 0.8);
          @include media('>=medium') {
            width: $quoteOpenSize;
            height: $quoteOpenSize;
          }
          svg {
            width: $quoteOpenSizeSM * 0.5 !important;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translateX(-50%) translateY(-50%);
            @include media('>=medium') {
              width: $quoteOpenSize * 0.5 !important;
            }
            path {
              fill: rgba(#fff, 1) !important;
            }
          }
          &.close {
            top: auto;
            left: auto;
            bottom: 10px;
            right: 0;
            transform: rotate(180deg) translateX(-50%) translateY(0%);
          }
        }
      }
    }
  }

  //---------------------
  // Colours
  //---------------------
  &--green {
    // background: pink;
    .sect-cs-header,
    .button--primary {
      background: $CaseStudyGreen !important;
    }
    .csSidebar .csSidebarWrap .csSidebarContent > span,
    .heading-two,
    .footer-cs-nav .prev:hover,
    .footer-cs-nav .prev:hover .label,
    .footer-cs-nav .next:hover,
    .footer-cs-nav .next:hover .label,
    .cs-quote-person {
      color: $CaseStudyGreen !important;
    }
    .heading-two {
      &:after {
        background: rgba($CaseStudyGreen, 0.7) !important;
      }
    }
    .footer-cs-nav .prev:hover .svg-icon path,
    .footer-cs-nav .next:hover .svg-icon path {
      fill: $CaseStudyGreen !important;
    }
    .csSidebar .csSidebarContent--quote .cs-quote-icon {
      background: rgba($CaseStudyGreen, 0.8) !important;
    }
    .sect-contact {
      .sect-content {
        // background: rgba(lighten($CaseStudyGreen, 20%), 0.1);
      }
      svg {
        g,
        g path {
          fill: $CaseStudyGreen !important;
        }
      }
      h3 {
        strong {
          color: $CaseStudyGreen;
        }
      }
    }
    .sect-cs-inclusions .list-wrap svg {
      g {
        path {
          fill: rgba($CaseStudyGreen, 0.8) !important;
        }
        circle {
          stroke: rgba($CaseStudyGreen, 0.8) !important;
        }
      }
    }
    .csSidebar .csSidebarContent svg,
    .sect-cs-header .csLoopNavInheader > span:hover svg {
      g,
      path,
      line,
      circle,
      ellipse,
      rect {
        fill: $CaseStudyGreen !important;
      }
      circle,
      ellipse,
      rect {
        fill: none;
      }
    }
  }
  &--blue {
    @include caseStudyTheme($CaseStudyBlue);
  }
  &--darkblue {
    @include caseStudyTheme($CaseStudyDarkBlue);
  }
  &--red {
    @include caseStudyTheme($CaseStudyRed);
  }
  &--orange {
    @include caseStudyTheme($CaseStudyOrange);
  }
  &--green {
    @include caseStudyTheme($CaseStudyGreen);
  }
  &--purple {
    @include caseStudyTheme($CaseStudyPurple);
  }
  &--brown {
    @include caseStudyTheme($CaseStudyBrown);
  }
}
</style>
